import { Grid, Typography } from '@mui/material'
import React from 'react'
import SelectField from '../../../../FormControl/input/SelectField'
import { setParentData } from '../../utils'

const AssesmentArea = ({ element, elementData, childrenElements = [], form, errors, onChange, parent }) => {
  const value = form[element?.elementStructureId]?.value || ''
  const dataSelected = childrenElements?.find((item) => item._id === value)
  
  return (
    <>
      <Grid item md={2} sm={3}>
        <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
          {elementData?.name}
        </Typography>
      </Grid>
      <Grid item md={9} sm={8}>
        <SelectField
          id={`${element?.elementStructureId}`}
          name={element?.elementStructureId}     
          className='capitalize'
          error={errors[element?.elementStructureId]}
          helperText={errors[element?.elementStructureId]}                    
          value={value}
          onChange={(e) => onChange(element?.elementStructureId, { value: e.target.value, parent })}      
          options={childrenElements?.map((item) => ({ value: item._id, label: item.name })) || [] }
          placeholder="Choose an option"
        />
      </Grid>
      { dataSelected?.elements?.map((item) => {
        const elData = elementData?.children?.find((el) => el._id === item.elementStructureId)
        return (
          <AssesmentArea
            key={`${element?.elementStructureId}-${item._id}`}
            element={item}
            childrenElements={item.children}
            form={form[element?.elementStructureId].children}
            errors={errors}
            onChange={onChange}
            elementData={elData}
            parent={setParentData({ _id: element?.elementStructureId }, parent)}
          />
        )
      })}
    </>
  )
}

export default AssesmentArea